import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store, { initializeStore } from './store';
import App from './App';
import { authStorage } from './platform/storage';
import { runtime } from './platform/runtime';
import { links } from './platform/links';
import notifications from './platform/notifications';
import IncomingLinks from './Components/NativeLinks/IncomingLinks';
import { biometrics } from './platform/biometrics';
import { ThemeProvider } from './context/ThemeContext';
// import { ToastContainer } from 'react-toastify';
// import reportWebVitals from './reportWebVitals';

document.addEventListener('mousemove', () => { // Tracks user activity so we know if we should auto log them out
    store.dispatch({ type: 'USER_ACTIVITY' });
});

if (runtime.isNative()) {
    void notifications.start().catch(() => { console.warn('Native push unavailable.'); });
    void notifications.retry().catch(() => {});

    const retryRevocations = () => { void authStorage.retryRevocations().catch(() => {}); };
    window.addEventListener('online', retryRevocations);
    retryRevocations();
    void biometrics.onResume(async () => {
        retryRevocations();
        await initializeStore();
        biometrics.resumed();
    });
}
void (async () => {
    try { await links.startIncomingLinks(); } catch { console.warn('Incoming links unavailable.'); }
    await initializeStore();
})();

let hasRendered = false;

const renderApp = () => {
    if (hasRendered) return;
    hasRendered = true;

    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <ThemeProvider>
                    <BrowserRouter>
                        <IncomingLinks><App /></IncomingLinks>
                        {/* <ToastContainer/> */}
                    </BrowserRouter>
                </ThemeProvider>
            </Provider>
        </React.StrictMode>
    );
};

const startRender = () => {
    // Prevent rare PWA boot hangs if fonts.ready never resolves.
    const FONT_READY_TIMEOUT_MS = 1500;

    if (document.fonts && document.fonts.ready) {
        Promise.race([
            document.fonts.ready,
            new Promise((resolve) => setTimeout(resolve, FONT_READY_TIMEOUT_MS))
        ]).finally(() => {
            renderApp();
        });
        return;
    }

    renderApp();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startRender, { once: true });
} else {
    startRender();
}
